import React, {Component} from "react";
import {Col, Input, Label} from "reactstrap";
import {
    appResponses, archiveStatus,
    cancelledStates,
    invoiceProfileTypesSelectData,
    invoiceTypesSelectData,
    showAxiosError,
    cancelPortalStatus
} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import DefaultModal from "../invoice/DefaultModal";
import Alert from "react-s-alert";
import {isValidSearchField} from "../../common/componentValidation";
import Select from "../../local_node_modules/react-select";
import Datetime from "react-datetime";
import moment from "moment";
import ReactLoading from "react-loading";
import {showBaro} from "../../helper/permission"
import {VirtualHost} from "../../constants";

class BuildReportModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error:{},
            selectedHeader:null,
            isDefault:false,
            excelHeaderList:[],
            vknTckns:[],
            index:null,
            searchFields:[
                {
                    label:'Fatura Tarihi',
                    name:'document_issue_date',
                    type:"between",
                    start:null,
                    end:null,
                    rule:'date',
                    input_type:'date',
                    enableShow:true,
                    isRelated: false,
                },
                {
                    label:'Alınma Tarihi',
                    name:'received_date',
                    type:"between",
                    start:null,
                    end:null,
                    rule:'date',
                    input_type:'date',
                    enableShow:true,
                    isRelated: false,
                },
                {
                    label:'Gönderici VKN/TCKN',
                    name:'source_id',
                    disabled:true,
                    type:'and',
                    start:null,
                    minLength:10,
                    maxLength:11,
                    rule:'0,11',
                    input_type:'input',
                    enableShow:true,
                    isRelated: true
                },
                {
                    label:'Alıcı VKN/TCKN',
                    name:'destination_id',
                    type:'and',
                    disabled:true,
                    start:null,
                    minLength:10,
                    maxLength:11,
                    rule:'0,11',
                    input_type: 'input',
                    enableShow:true,
                    isRelated: true
                },
                {
                    label:'Senaryo Türü',
                    name:'document_profile',
                    type:'and',
                    start:null,
                    input_type:'select',
                    rule:'0,45',
                    options:invoiceProfileTypesSelectData(),
                    enableShow:true,
                    isRelated: true
                },
                {
                    label:'Fatura Türü',
                    name:'invoice_type_code',
                    type:'and',
                    start:null,
                    input_type:'select',
                    rule:'0,45',
                    options:invoiceTypesSelectData(),
                    enableShow:true,
                    isRelated: true
                },
                /*{
                    label:'Fatura Durumu',
                    name:'invoice_state',
                    type:'and',
                    start:null,
                    input_type:'select',
                    rule:'0,45',
                    options:invoiceStates()
                },*/
                {
                    label: "Cevap Durumu",
                    name: "response_code",
                    type:'and',
                    start:null,
                    input_type:'select',
                    rule:'0,45',
                    options: appResponses(),
                    enableShow:true,
                    isRelated: false,
                },
                {
                    label: "İptal Durumu",
                    name: "cancelled",
                    type:'and',
                    start:null,
                    input_type:'select',
                    rule:'0,45',
                    options: cancelledStates(),
                    enableShow:true,
                    isRelated: false,
                },
                {
                    label: "Arşiv Durumu",
                    name: "is_archive",
                    type:'and',
                    start:null,
                    input_type:'select',
                    rule:'0,45',
                    options: archiveStatus(),
                    enableShow:true,
                    isRelated: false,
                },
                {
                    label: "İptal Portalı Durumu",
                    name: "cancel_portal_status",
                    type:'and',
                    start:null,
                    input_type:'select',
                    rule:'0,45',
                    options: cancelPortalStatus(),
                    enableShow:true,
                    isRelated: false,
                },
                {
                    label:'Fatura No',
                    name:'document_id',
                    type:'and',
                    start:null,
                    minLength:1,
                    maxLength:45,
                    rule:'0,45',
                    input_type: 'input',
                    enableShow:true,
                    isRelated: true,
                },
                {
                    label: "Tarih Formatı",
                    name: "date_format",
                    type:'and',
                    start:"0",
                    input_type:'select',
                    options: [
                        {value: "0", label: "19-05-1919 (-)"},
                        {value: "1", label: "19.05.1919 (.)"},
                        {value: "2", label: "19/05/1919 (/)"},
                    ],
                    enableShow:true,
                    isRelated: false,
                },
                {
                    label: "Fatura Türü",
                    name: "eczacipos_invoice_type",
                    type: 'and',
                    start: null,
                    input_type: 'select',
                    options: [
                        {value: null, label: "Hepsi"},
                        {value: "eArchive", label: "eArşiv"},
                        {value: "eInvoice", label: "eFatura"},
                    ],
                    enableShow: false,
                    isRelated: false,
                }
            ],
            disableSaveButton: false
        };
        this.setSearchFields     = this.setSearchFields.bind(this);
        this.onChange            = this.onChange.bind(this);
        this.onChangeExcelHeader = this.onChangeExcelHeader.bind(this);
        this.saveClicked         = this.saveClicked.bind(this);
        this.getExcelHeaderList  = this.getExcelHeaderList.bind(this);
        this.copyValuesFromProps = this.copyValuesFromProps.bind(this);
        this.cancel = this.cancel.bind(this);
    }

    componentDidMount() {
        let self=this;
        self.getExcelHeaderList();

    }

    getExcelHeaderList(){
        let self = this;
        self.setState({ loading:true});
        request({
            url: `/excelXpath/getExcelHeaderList`,
            method: 'post',
            data: "getExcelHeaderList"
        }).then(response => {
            let data = response.data;
            console.log("Data", data)
            let excelHeaderList = data.excelHeaderList.filter((item => item.hasLine === self.props.hasLine));
            if(showBaro()) {
                excelHeaderList = excelHeaderList.filter(header => header.documentType === "SERBESTMESLEKMAKBUZ");
            } else if ("faturam24" === VirtualHost.conf.resourcePrefix) {
                excelHeaderList = excelHeaderList.filter(header => header.documentType === "EARSIV5BINOTUZBIN");
            }

            let vknTckns = data.vknTckns;
            vknTckns.push(self.props.vknTckn);
            self.setState({excelHeaderList,vknTckns,loading:false},() => this.copyValuesFromProps());

            if (self.props.sgkCiroReport && self.props.sgkCiroReport === true) {
                let index = excelHeaderList.findIndex(h => h.type === "SGK_REPORT");
                if (index > -1) {
                    this.onChangeExcelHeader(index);
                }
            }
        }).catch(error => {
            showAxiosError(error);
            self.setState({loading:false});
        });
    }

    copyValuesFromProps(){
        let self=this;
        if(self.props.mode === 'copy' && self.props.itemToBeCopied){
            let searchFields = JSON.parse(self.props.itemToBeCopied.searchField);
            let headerName = self.props.itemToBeCopied.name;
            let index = (this.state.excelHeaderList.findIndex(element=> element.name===headerName));
            if(index === -1){
                Alert.closeAll();
                Alert.error("Hata oluştu!", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 8000
                });
                this.cancel();
                return;
            }
            else {
                if(searchFields.findIndex(field => {return field.name === "date_format"}) === -1){
                    searchFields.push({
                        label: "Tarih Formatı",
                        name: "date_format",
                        type:'and',
                        start:"0",
                        input_type:'select',
                        options: [
                            {value: "0", label: "19-05-1919 (-)"},
                            {value: "1", label: "19.05.1919 (.)"},
                            {value: "2", label: "19/05/1919 (/)"},
                        ],
                        enableShow:true,
                        isRelated: false,
                    })
                }
                self.setState({searchFields,index},()=>self.onChangeExcelHeader(index));
            }
        }
    }

    setSearchFields(){
        let self = this;
        let {searchFields,selectedHeader} =self.state;
        searchFields.map(function (data) {
            if (["inbox", "despatch_inbox", "inbox_transfer"].includes(selectedHeader.type)) {
                if (data.name === "destination_id") {
                    data.input_type = "select";
                    data.disabled = self.state.vknTckns.length === 1;
                    data.start = self.props.vknTckn;
                    data.options = self.state.vknTckns.map((vknTckn) => ({label: vknTckn, value: vknTckn}));
                }
                if (data.name === "source_id") {
                    data.input_type = "input";
                    data.start = null;
                    data.disabled = false;
                }
            }else{
                if(data.name === "destination_id"){
                    data.input_type="input";
                    data.start=null;
                    data.disabled=false;
                }
                if(data.name === "source_id"){
                    data.input_type="select";
                    data.disabled= self.state.vknTckns.length===1;
                    data.start=self.props.vknTckn;
                    data.options = self.state.vknTckns.map((vknTckn)=>({label:vknTckn,value:vknTckn}));
                }
            }

            if(data.name === "cancelled"){
                if(selectedHeader.type === "archive_invoice_transfer"){
                    data.disabled= true;
                    data.start = null;
                }else if(selectedHeader.type.indexOf("archive_") !== -1){
                    data.disabled= false;
                }else{
                    data.disabled= true;
                    data.start=null;
                }
            }

            if (data.name === "cancel_portal_status") {
                if (selectedHeader.type === "outbox_transfer" || selectedHeader.type === "inbox_transfer") {
                    data.disabled = true;
                    data.start = null;
                } else if ((selectedHeader.type.indexOf("outbox") !== -1 || selectedHeader.type.indexOf("inbox") != -1)) {
                    data.disabled = false;
                } else {
                    data.disabled = true;
                    data.start = null;
                }
            }

            if (data.name === "luca_date_format") {
                if (selectedHeader.name.includes("luca")) {
                    data.disabled = true;
                    data.start = "0";
                } else {
                    data.disabled = false;
                }
            }

            if (data.name === "is_archive") {
                if (selectedHeader.type === "outbox_transfer" || selectedHeader.type === "inbox_transfer" || selectedHeader.type === "archive_invoice_transfer") {
                    data.start = null;
                    data.disabled = true;
                }else {
                    data.disabled = false;
                }
            }


            if (data.name === "response_code") {
                if (selectedHeader.type.indexOf("archive_") !== -1 || selectedHeader.type === "egiderpusulasi" || selectedHeader.type === "outbox_transfer" || selectedHeader.type === "inbox_transfer") {
                    data.start = null;
                    data.disabled = true;
                } else {
                    data.disabled = false;
                    data.options = appResponses();
                }
            }

            if(data.name === "document_profile") {
                if (selectedHeader.type === "archive_invoice") {
                    data.start = "EARSIVFATURA";
                    data.disabled = true;
                    data.options = [{label: "EARSIVFATURA", value: "EARSIVFATURA"}]
                } else if (selectedHeader.type === "outbox-archive_invoice") {
                    data.start = "EFATURA - EARSIVFATURA";
                    data.disabled = true;
                    data.options = [{label: "EFATURA - EARSIVFATURA", value: "EFATURA - EARSIVFATURA"}]
                } else if(selectedHeader.type === "archive_voucher"){
                    data.start = "EARSIVBELGE";
                    data.disabled = true;
                    data.options = [{label: "EARSIVBELGE", value: "EARSIVBELGE"}]
                } else if(selectedHeader.type === "egiderpusulasi"){
                    data.start = "EGIDERPUSULASI";
                    data.disabled = true;
                    data.options = [{label: "EGIDERPUSULASI", value: "EGIDERPUSULASI"}]
                } else if (selectedHeader.type === "archive_invoice_transfer"){
                    data.start = null;
                    data.disabled = false;
                    data.options = [{value: null, label: 'Tümü'},{value: "EARSIVFATURA", label: "EARSIVFATURA"}, {value: 'TEMELFATURA', label: 'Temel Fatura'}]
                } else {
                    data.start = null;
                    data.disabled = false;
                    data.options = invoiceProfileTypesSelectData()
                }
            }

            if (data.name === 'invoice_type_code') {
                data.start = null;
                if (selectedHeader.type === "archive_voucher" || selectedHeader.type === "egiderpusulasi" || selectedHeader.type === "outbox-archive_invoice" || selectedHeader.type === "archive_invoice_transfer") {
                    data.disabled = true;
                }else {
                    data.disabled = false;
                }
            }

            if(selectedHeader.documentType === "SERBESTMESLEKMAKBUZ" || selectedHeader.documentType === "MUSTAHSILMAKBUZ"){
                if(data.name === "document_issue_date"){
                    data.label = "Makbuz Tarihi";
                }
                if(data.name ==="received_date" || data.name === "response_code" || data.name === "invoice_type_code"){
                    data.enableShow = false;
                }
                else{
                    data.enableShow = true;
                }

            } else if(selectedHeader.type === "egiderpusulasi"){
                if(data.name === "document_issue_date"){
                    data.label = "Pusula Tarihi";
                }
                data.enableShow = true;
            } else{
                if(data.name === "document_issue_date"){
                    data.label = "Fatura Tarihi";


                }
                data.enableShow = true;

            }

            if (["SGK_REPORT", "ECZACIPOS_SALES_REPORT"].includes(selectedHeader.type)) {
                if ("SGK_REPORT" === selectedHeader.type) {
                    if (data.name === "destination_id") {
                        data.input_type = "select";
                        data.start = "7750409379";
                        data.disabled = true;
                        data.options = [{label: "7750409379", value: "7750409379"}];
                    }
                } else {
                    if (data.name === "destination_id") {
                        data.input_type = "select";
                        data.start = null;
                        data.disabled = true;
                        data.enableShow = false;
                        data.options = [];
                    }

                    if (data.name === "eczacipos_invoice_type") {
                        data.enableShow = true;
                        data.input_type = "select";
                        data.start = null;
                    }

                    if ("date_format" === data.name) {
                        data.enableShow = false;
                    }
                }

                if (data.name === "source_id") {
                    data.input_type = "select";
                    data.disabled = true;
                    data.start = self.props.vknTckn;
                    data.options = [{label: self.props.vknTckn, value: self.props.vknTckn}];
                }

                if (["document_profile", "invoice_type_code", "document_id", "received_date", "response_code", "cancelled", "is_archive", "cancel_portal_status"].includes(data.name)) {
                    data.enableShow = false;
                }
            }

            return data;
        });

        self.setState({searchFields});
    }

    onChangeExcelHeader(index) {
        let excelHeader = this.state.excelHeaderList[index];
        this.setState({isDefault:excelHeader.isDefault,index, selectedHeader:excelHeader},()=>this.setSearchFields());
    }

    onChange(name, value, index) {
        let searchFields = this.state.searchFields;
        if( searchFields[index].type === 'between' && name.indexOf('_end') !== -1)
            searchFields[index].end = value;
        else
            searchFields[index].start = value;
        this.setState({searchFields});
    }

    saveClicked() {
        let self = this;
        const selectedHeader = self.state.selectedHeader;
        if(!selectedHeader){
            Alert.error("Rapor Türü seçili olmalı", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 8000
            });
            return;
        }

        self.setState({saveLoading:true});
        let result = isValidSearchField(self.state.searchFields, selectedHeader.type);
        let error = result.error;
        let valid = result.valid;
        if (valid) {
            let params = {
                url: `/excelRequest/save/` + self.state.isDefault + '/' + self.state.selectedHeader.recordId,
                method: 'post',
                data: self.state.searchFields
            };
            request(params)
                .then(response => {
                    Alert.success(response.data, {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 1000
                    });
                    self.setState({disableSaveButton: false});
                    self.props.toggle();
                }).catch(error => {
                self.setState({disableSaveButton: false});
                showAxiosError(error);
            });
        }else{
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 8000
            });
            this.setState({error: error});
        }
    }

    cancel() {
        this.props.toggle();
    }

    render() {
        let {loading} = this.state;
        let isRelated = ["source_id","document_profile","destination_id","invoice_type_code","document_id"];
        return (
            <DefaultModal
                disabled={this.state.disableSaveButton}
                isOpen={this.props.show}
                title={this.props.mode==='create'?"Rapor Oluştur":"Eski Rapordan Kopyala"}
                size="xl"
                confirmBtnText="Oluştur"
                onConfirm={this.saveClicked}
                onCancel={()=>this.props.toggle()}>
                <Col sm="12">
                    {loading &&
                        <ReactLoading type="spinningBubbles" style={{
                            width: "40px",
                            height: "40px",
                            margin: "20px auto 0 auto",
                            fill: "#888"
                        }}/>
                    }
                    {!loading &&
                        <div>
                            <div className="row">
                                <Label sm={2} for='selectedExcelHeader' style={{fontWeight: 'bold'}}>Rapor Türü:</Label>
                                <Col sm={10}>
                                    <Select
                                        clearable={false}
                                        className="select-control"
                                        name="selectedExcelHeader"
                                        value={this.state.index}
                                        placeholder="Seçiniz..."
                                        onChange={(e) => e && this.onChangeExcelHeader(e.value)}
                                        options={this.state.excelHeaderList.map((excelHeader, index) => ({
                                            value: index,
                                            label: excelHeader.name
                                        }))}/>
                                </Col>
                            </div>

                            <div className="row mt-2">
                                <div className="col mr-2">
                                    <div className="row">
                                        <Label sm={12} for='selectedExcelHeader' className={"text-center"}
                                               style={{fontWeight: 'bold', textDecoration: 'underline'}}>Tarih Aralığı</Label>
                                        {this.state.searchFields.map((searchField, index) =>
                                            searchField.enableShow ?
                                                <React.Fragment>
                                                    {searchField.input_type === 'date' &&
                                                        <React.Fragment>
                                                            <div className="col-sm-12 row mt-4">
                                                                <Label sm={7} for={searchField.name + '_start'}
                                                                       style={{fontWeight: 'bold'}}>{searchField.label + '(Başlangıç):'}</Label>
                                                                <Col sm={5} className="px-0">
                                                                    {searchField.input_type === 'date' &&
                                                                        <Datetime locale="tr"
                                                                                  id={searchField.name + '_start'}
                                                                                  className="datepicker"
                                                                                  input={true}
                                                                                  closeOnSelect={true}
                                                                                  value={moment(searchField.start, "YYYY-MM-DD", true).isValid() ? moment(searchField.start).format("DD-MM-YYYY") : searchField.start}
                                                                                  dateFormat="DD-MM-YYYY"
                                                                                  timeFormat={false}
                                                                                  onChange={(value) => (value && !(typeof value === "string")) && this.onChange(searchField.name, value.format("YYYY-MM-DD"), index)}/>
                                                                    }
                                                                </Col>
                                                            </div>
                                                            <div className="col-sm-12 row mt-3">
                                                                <Label sm={7} for={searchField.name + '_end'}
                                                                       style={{fontWeight: 'bold'}}>{searchField.label + '(Bitiş):'}</Label>
                                                                <Col sm={5} className="px-0">
                                                                    {searchField.input_type === 'date' &&
                                                                        <Datetime locale="tr"
                                                                                  id={searchField.name + '_end'}
                                                                                  className="datepicker"
                                                                                  input={true}
                                                                                  closeOnSelect={true}
                                                                                  value={moment(searchField.end, "YYYY-MM-DD", true).isValid() ? moment(searchField.end).format("DD-MM-YYYY") : searchField.end}
                                                                                  dateFormat="DD-MM-YYYY"
                                                                                  timeFormat={false}
                                                                                  onChange={(value) => (value && !(typeof value === "string")) && this.onChange(searchField.name + '_end', value.format("YYYY-MM-DD"), index)}/>
                                                                    }
                                                                </Col>
                                                            </div>
                                                        </React.Fragment>
                                                    }
                                                </React.Fragment>
                                                : null
                                        )}
                                    </div>
                                </div>

                                <div className="verticaLine"></div>

                                <div className="col ml-2">
                                    <div className="row">
                                        <Label sm={12} for='selectedExcelHeader' className={"text-center"}
                                               style={{fontWeight: 'bold', textDecoration: 'underline'}}>Fatura Bilgileri</Label>
                                        {this.state.searchFields.map((searchField, index) =>
                                            searchField.enableShow ?
                                                <React.Fragment>
                                                    {(searchField.isRelated || isRelated.includes(searchField.name)) && (searchField.input_type === 'select' || searchField.input_type === 'input') &&
                                                        <React.Fragment>
                                                            <div className="col-sm-12 row mt-3">
                                                                <Label sm={7} for={searchField.name}
                                                                       style={{fontWeight: 'bold'}}>{searchField.label + ':'}</Label>
                                                                <Col sm={5} className="px-0">
                                                                    {searchField.input_type === 'select' &&
                                                                        <Select
                                                                            clearable={false}
                                                                            disabled={searchField.disabled}
                                                                            className="select-control"
                                                                            name={searchField.name}
                                                                            value={searchField.start}
                                                                            placeholder="Seçiniz..."
                                                                            onChange={(e) => this.onChange(searchField.name, e.value, index)}
                                                                            options={searchField.options}
                                                                        />
                                                                    }
                                                                    {searchField.input_type === 'input' &&
                                                                        <Input type="text"
                                                                               disabled={searchField.disabled}
                                                                               minLength={searchField.minLength}
                                                                               maxLength={searchField.maxLength}
                                                                               name={searchField.name}
                                                                               value={searchField.start}
                                                                               onChange={(e) => this.onChange(searchField.name, e.target.value, index)}/>
                                                                    }
                                                                </Col>
                                                            </div>
                                                        </React.Fragment>
                                                    }
                                                </React.Fragment>
                                                : null
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="horizontalLine mt-4" />

                            <div className="row mt-2 mb-3">
                                <Label sm={12} for='selectedExcelHeader' className={"text-center"}
                                       style={{fontWeight: 'bold', textDecoration: 'underline'}}>Fatura Durumu</Label>
                                {this.state.searchFields.map((searchField, index) =>
                                    searchField.enableShow ?
                                        <React.Fragment>
                                            {(!searchField.isRelated && !isRelated.includes(searchField.name)) && (searchField.input_type === 'select' || searchField.input_type === 'input') &&
                                                <React.Fragment>
                                                    <div className="col-sm-6 row mt-3">
                                                        <Label sm={6} for={searchField.name}
                                                               style={{fontWeight: 'bold'}}>{searchField.label + ':'}</Label>
                                                        <Col sm={6} className="px-0">
                                                            {searchField.input_type === 'select' &&
                                                                <Select
                                                                    clearable={false}
                                                                    disabled={searchField.disabled}
                                                                    className="select-control"
                                                                    name={searchField.name}
                                                                    value={searchField.start}
                                                                    placeholder="Seçiniz..."
                                                                    onChange={(e) => this.onChange(searchField.name, e.value, index)}
                                                                    options={searchField.options}
                                                                />
                                                            }
                                                            {searchField.input_type === 'input' &&
                                                                <Input type="text"
                                                                       disabled={searchField.disabled}
                                                                       minLength={searchField.minLength}
                                                                       maxLength={searchField.maxLength}
                                                                       name={searchField.name}
                                                                       value={searchField.start}
                                                                       onChange={(e) => this.onChange(searchField.name, e.target.value, index)}/>
                                                            }
                                                        </Col>
                                                    </div>
                                                </React.Fragment>
                                            }
                                        </React.Fragment>
                                        : null
                                )}
                            </div>

                        </div>
                    }
                </Col>
            </DefaultModal>
        );
    }
}

export default BuildReportModal;